const ShiftStatus = ({ statusList = [] }) => {
  console.log('statusList >>', statusList)
  const status = statusList.join('-')
  if (['2-3','3-2'].includes(status)) {
    return (
      <div className="shift">
        <div className="status danger"></div>
        <h5>เข้างานสาย - ออกงานก่อน</h5>
      </div>
    )
  }
  if (statusList == 2) {
    return (
      <div className="shift">
        <div className="status danger"></div>
        <h5>เข้างานสาย - ออกงาน</h5>
      </div>
    )
  }
  if (statusList == 3) {
    return (
      <div className="shift">
        <div className="status warning"></div>
        <h5>เข้างาน - ออกงานก่อน</h5>
      </div>
    )
  }
  if (statusList == 1) {
    return (
      <div className="shift">
        <div className="status blue"></div>
        <h5>เข้างาน - ออกงาน</h5>
      </div>
    )
  }
  return '-'
}
export default ShiftStatus